'use es6';

import { Component } from 'react';
import omit from '../utils/underscore/omit';
import UIStepperInput from './UIStepperInput';
import { jsx as _jsx } from "react/jsx-runtime";
class UIPercentageStepper extends Component {
  render() {
    return /*#__PURE__*/_jsx(UIStepperInput, Object.assign({}, this.props, {
      formatStyle: "percentage"
    }));
  }
}
UIPercentageStepper.displayName = 'UIPercentageStepper';
UIPercentageStepper.propTypes = Object.assign({}, omit(UIStepperInput.propTypes, ['formatStyle', 'currency']));
UIPercentageStepper.defaultProps = Object.assign({}, UIStepperInput.defaultProps);
export default UIPercentageStepper;